import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import FormHelperText from '@material-ui/core/FormHelperText'
import { useField } from 'formik'

type CheckboxProps = {
  disabled?: boolean
  label?: string
  name: string
  style?: {}
  onClick?: (e) => void
}

const ValidatedCheckbox = (props: CheckboxProps) => {
  const { disabled, label, name, style, onClick } = props
  const [field, meta] = useField(name)

  const error = !!(meta.error && meta.touched)
  const helperText = error ? meta.error : null

  return (
    <>
      <FormControlLabel
        {...field}
        control={<Checkbox style={style} disabled={disabled} color="primary" checked={meta.value} onClick={onClick} />}
        label={label}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </>
  )
}

export default ValidatedCheckbox
